import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import { TicketCard } from "./TicketCard";
import { join, pathOr } from "ramda";
import React from "react";
import { useGlobal } from "reactn";

export const TicketList = ({ tickets, justify = "start", referrer }) => {
	const [offices] = useGlobal("offices");

	return (
		<Row justify={justify} align="middle" gutter={24}>
			{tickets.map((ticket) => {
				const office = offices[ticket.office];
				const virtualRoom = pathOr(
					false,
					["options", "virtualRoom"],
					office
				);

				return (
					<Col key={ticket.tuid}>
						<Link
							to={{
								pathname: virtualRoom
									? `/waiting-room/${ticket.office}/${ticket.lineSlug}/${ticket.tuid}`
									: "/" +
									  join("/", [
											"ticket",
											ticket.officeSlug || ticket.office,
											ticket.lineSlug || ticket.line,
											ticket.tuid,
									  ]),
								state: { referrer },
							}}
						>
							<TicketCard ticket={ticket} />
						</Link>
					</Col>
				);
			})}
		</Row>
	);
};
